import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/webduan/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/app/tim-kiem/VoiceSearchBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/ProductSpecsHoverCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/ui/AppImage.tsx");
